<template>
  <div>
    <span v-if="checked">已核算</span>
    <span v-else :class="data.status === 'add' ? 'red' : ''">{{ type[data.status] }}</span>
  </div>
</template>

<script>
// import {
//   tkDate
// } from '@moke/vue-tk'
export default {
  props: ['data'],
  data () {
    return {
      type: {

        add: '新订订单',
        read: '已读订单',
        madeing: '生产中订单',
        transit: '运输中订单',
        complete: '生产完成订单',
        sent: '已发出订单',
        deliveriesTaked: '已收货订单',
        // confirmed: '审完成订单',
        finish: '已完成订单',
      },
      checked: false
    }
  },
  mounted () {
    // console.log(this.data)
    // console.log(this.$tkDate(this.data.orderDate).format())
    // console.log(this.$tkDate(this.$tkDate(this.data.orderDate).format()).toTimestamp())
    // console.log(this.$tkDate('2021-08-26 23:59').toTimestamp())
    if (this.$tkDate(this.$tkDate(this.data.orderDate).format()).toTimestamp() < this.$tkDate('2021-08-26 23:59').toTimestamp()) {
      this.checked = true
    }
    // console.log('ccchecked', this.checked)
  }
}
</script>

<style scoped>
.red {
  color: red;
}
</style>
